import * as types from "./actionTypes";
import initialState from "../store/initialState";
import { getLayout } from "../store/configureStore";
import mergeDeep from '../util/mergeDeep';
import * as DomainConstants from '../constants/DomainConstants';

export function layoutUpdated(layout) {
	return {
		type: types.LAYOUT_UPDATED,
		body: layout
	};
}

export function voortgangsRapportLoaded() {
	return {
		type: types.VOORTGANGSRAPPORT_LOADED,
		body: true
	};
}

export function notifyLoadedVoortgangsrapport(){
	return function (dispatch) {
		return dispatch(voortgangsRapportLoaded());
	};
}

export function loadDefaultLayout() {
	return function (dispatch) {

		let layout = mergeDeep({}, initialState.layout);
		layout.showVoortgangsrapportLayout = true;

		return dispatch(layoutUpdated(layout));
	};
}

export function setDisabledInputComponents(disabled) {
	return function (dispatch) {

		let layout = mergeDeep({}, initialState.layout);
		layout.disableInputComponents = disabled;

		return dispatch(layoutUpdated(layout));
	};
}

export function loadVRProjectPageLayout(projectTitle, locatie, voortgangsrapportId, initialisatieOK, verantwoordingVisible) {
	return function (dispatch) {

		let layout = getLayout();
		layout.showVoortgangsrapportLayout = true;
		layout.showTopNav = true;
		layout.showBeads = true;
		layout.showSideNav = false;

		layout.voortgangsrapportTopNavTabSettings = mergeDeep({}, layout.voortgangsrapportTopNavTabSettings, getEnabledWithUrlTabs(voortgangsrapportId, initialisatieOK));
		layout.pageHeaderTitle = projectTitle;
		layout.pageHeaderSubtitle = locatie;
		layout.voortgangsrapportTopNavTabSettings.beoordelingscriteriaTab.visible = true;
		layout.voortgangsrapportTopNavTabSettings.verantwoordingTab.visible = verantwoordingVisible;
		layout.voortgangsrapportTopNavTabSettings.indienenTab.visible = true;


		return dispatch(layoutUpdated(layout));
	};
}

export function loadVRPageLayout(voortgangsrapportId, initialisatieOK) {
	return function (dispatch) {

		let layout = getLayout();
		layout.showVoortgangsrapportLayout = true;
		layout.showTopNav = true;
		layout.showBeads = true;
		layout.showSideNav = false;

		layout.voortgangsrapportTopNavTabSettings = mergeDeep({}, layout.voortgangsrapportTopNavTabSettings, getEnabledWithUrlTabs(voortgangsrapportId, initialisatieOK));

		return dispatch(layoutUpdated(layout));
	};
}

export function loadIndienenBevestigingPageLayout(voortgangsrapportId) { // will need dossierInitialised
	return function (dispatch) {

		let layout = getLayout();
		layout.voortgangsrapportTopNavTabSettings.indienenTab.disabled = false;
		layout.voortgangsrapportTopNavTabSettings.indienenTab.urlSuffix = "/" + voortgangsrapportId;
		layout.showTopNav = true;
		layout.showBeads = true;

		return dispatch(layoutUpdated(layout));
	};
}

function getEnabledWithUrlTabs(voortgangsrapportId, rapportInitialised) {
	return ({
		projectTab: { disabled: false, urlSuffix: "/" + voortgangsrapportId },
		beoordelingscriteriaTab: { disabled: !rapportInitialised, urlSuffix: "/" + voortgangsrapportId },
		verantwoordingTab: { disabled: !rapportInitialised, urlSuffix: "/" + voortgangsrapportId },
		indienenTab: { disabled: !rapportInitialised, urlSuffix: "/" + voortgangsrapportId }
	});
}